import React from 'react';
import { ContentWrapperStyled } from './content-wrapper.component.style';
export const ContentWrapper = (props) => {
    return React.createElement(ContentWrapperStyled, null, props.children);
};
